export default __webpack_public_path__ + "static/01 - OLIVERIO DUHALDE PHOTO 2021_SMALL-b4f0b83b0ba1383e89eaa5fc32759753.png";